import React, { memo } from 'react';
import moment from 'moment';
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  // PDFViewer,
  Font,
} from '@react-pdf/renderer';

import Information from './information';
// import ConcernsTable from './ConcernsTable';
import Table from './Table';
import AuthHistory from './AuthHistory';
import InvoiceTotal from './InvoiceTotal';
import ExtraAmount from './ExtraAmount';
import { Header, Footer } from '../../../constants';
import TransactionHistory from './TransationHistory';

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf',
      fontWeight: 400,
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf',
      fontWeight: 500,
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf',
      fontWeight: 600,
    },
  ],
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 90,
    paddingBottom: 150,
    paddingLeft: 25,
    paddingRight: 25,
    fontFamily: 'Roboto',
    backgroundColor: '#fff',
    color: '#29264A',
    letterSpacing: '.6px',
    display: 'flex',
    flexDirection: 'column',
  },
  title__main: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: '600',
    lineHeight: '1.8px',
  },
  title: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
    lineHeight: '1.5px',
  },
  title__sm: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '400',
    lineHeight: '1.9px',
  },
  title__sm__footer: {
    fontSize: 7.5,
    fontFamily: 'Roboto',
    fontWeight: '400',
    lineHeight: '1.2px',
  },
  torque: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '600',
    lineHeight: '1.5px',
    color: '#6921C4',
  },
  headerContainer: {
    marginBottom: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    top: 8,
    left: 0,
    right: 0,
    paddingTop: 10,
    paddingLeft: 25,
    paddingRight: 25,
    paddingBottom: 10,
  },
  flex__start: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flex__end: {
    alignItems: 'center',
  },
  leftColumn: {
    flexDirection: 'column',
    flexGrow: 9,
  },

  image: {
    width: '125px',
    height: '75px',
    paddingBottom: 10,
  },
  image2: {
    width: '100px',
    height: '60px',
  },
  leftColumnContent: {
    marginLeft: 10,
    flexDirection: 'column',
    flexGrow: 9,
  },
  footer: {
    position: 'absolute',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    bottom: 8,
    left: 0,
    right: 0,
    borderTop: '1px solid #8A9EAF',
    paddingTop: 8,
    marginTop: 10,
    marginLeft: 25,
    marginRight: 25,
    marginBottom: 10,
  },
  align__center: {
    alignItems: 'center',
  },
  entryContainer: {
    flexGrow: 1,
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  invoice__total__container: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
});

const InvoicePreview = ({ data }) => {
  const userData = JSON.parse(localStorage.getItem('userData')) || '';

  const { userStore = '' } = userData;
  const {
    profileImg = '',
    businessName = '',
    address = '',
    email = '',
    registrationNumber = '',
    phoneNum = '',
    mobileNum = '',
    userId = '',
    documentBranding = '',
  } = userStore;
  const {
    repairOrderId,
    // concerns = [],
    invoice = '',
    createdAt = '', // ro created at
    invoiceTemplate = [],
    authHistory = [],

    addCommasToNumber,
  } = data || '';
  const showAuthorizationHistory =
    invoiceTemplate.find((temp) => temp['authorizationHistory'] === true) ||
    false;

  const changeLogo = Header?.includes(userId);
  const hideFooter = Footer?.includes(userId) || false;
  console.log('PDF>>>>data', data);
  return (
    <>
      {/* <PDFViewer> */}
      <Document>
        <Page size='A4' style={styles.body} wrap>
          <View style={styles.headerContainer} fixed>
            <View style={styles.flex__start}>
              <View style={styles.leftColumn}>
                <Image
                  src={profileImg || 'data:,'}
                  style={changeLogo ? styles.image2 : styles.image}
                />
              </View>
              <View style={styles.leftColumnContent}>
                <Text style={styles.title__main}>{businessName}</Text>
                <Text style={styles.title__sm}>{address} </Text>
                <Text style={styles.title__sm}>{email} </Text>
                <Text style={styles.title__sm}>{mobileNum || phoneNum}</Text>
                <Text style={styles.title__sm}>{registrationNumber} </Text>
              </View>
            </View>
            <View style={styles.flex__end}>
              <Text style={styles.title__sm}>
                REF RO#:
                <Text style={styles.title}> {repairOrderId}</Text>
              </Text>
              <Text style={styles.title__sm}>
                Invoice #:
                <Text style={styles.title}>
                  INV-{invoice?.id ? invoice?.id : '-'}
                </Text>
              </Text>
              <Text style={styles.title__sm}>
                Invoice Date:
                <Text style={styles.title}>
                  {' '}
                  {invoice?.createdAt
                    ? moment(invoice?.createdAt)?.format('MM/DD/YYYY')
                    : ''}
                </Text>
              </Text>
              <Text style={styles.title__sm}>
                Order Date:
                <Text style={styles.title}>
                  {' '}
                  {createdAt ? moment(createdAt).format('MM/DD/YYYY') : ''}
                </Text>
              </Text>
            </View>
          </View>
          <View style={styles.entryContainer}>
            <Information data={data} />
            {/* <ConcernsTable
              concerns={concerns}
              invoiceTemplate={invoiceTemplate}
            /> */}
            <Table data={data} />
            <ExtraAmount data={data} />
            <View style={styles.invoice__total__container} wrap>
              <InvoiceTotal data={data} userId={userId} />
            </View>
            <View break>
              {showAuthorizationHistory && (
                <TransactionHistory
                  data={data}
                  addCommasToNumber={addCommasToNumber}
                />
              )}
            </View>
            <View wrap={false}>
              {showAuthorizationHistory && (
                <AuthHistory
                  authHistory={authHistory}
                  addCommasToNumber={addCommasToNumber}
                />
              )}
            </View>
          </View>
          <View style={styles.footer} fixed>
            <Text style={styles.title__sm__footer}>
              {moment().format('MM/DD/YYYY')}
            </Text>
            {!hideFooter && (
              <View style={styles.align__center}>
                <Text style={styles.title}>{businessName}</Text>
                <Text style={styles.title__sm__footer}>
                  {documentBranding ? (
                    documentBranding
                  ) : (
                    <>
                      Powered by <Text style={styles.torque}>Torque360</Text> -
                      #1 All in one auto repair software
                    </>
                  )}
                </Text>
              </View>
            )}
            <Text
              style={styles.title__sm__footer}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} of ${totalPages}`
              }
            />
          </View>
        </Page>
      </Document>
      {/* </PDFViewer> */}
    </>
  );
};

export default memo(InvoicePreview);
